<template>
    <div>
        <button :class="triggerClass" @click.prevent="open">
            <slot name="modal-trigger"></slot>
        </button>
        <div class="modal-wrapper" :class="currentClass" v-show="isOpen">
            <div class="modal-overlay" @click.prevent="close"></div>
            <div class="modal">
                <button class="modal-close-button" type="button" @click.prevent="close"></button>
                <div class="modal-inner">
                    <slot name="modal-content"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name : "Modal",
        props: {
            triggerClass: {
                default: 'block'
            }
        },

        data() {
            return {
                isOpen      : false,
                currentClass: 'modal-closed',
            }
        },

        methods: {

            open() {
                this.$emit('open');
                this.isOpen = true;
                this.modalOpening();
                setTimeout(() => {
                    this.modalOpen();
                }, 640);
            },

            close() {
                this.$emit('close')
                this.modalClosing();
                setTimeout(() => {
                    this.modalClosed();
                    this.isOpen = false;
                }, 640);
            },

            modalOpening() {
                document.body.classList.remove('modal-closed');
                document.body.classList.add('modal-opening');
                this.currentClass = 'modal-opening';
            },
            modalOpen() {
                document.body.classList.replace('modal-opening', 'modal-open');
                this.currentClass = 'modal-open';
            },
            modalClosing() {
                document.body.classList.replace('modal-open', 'modal-closing');
                this.currentClass = 'modal-closing';
            },
            modalClosed() {
                document.body.classList.replace('modal-closing', 'modal-closed');
                this.currentClass = 'modal-closed';
            },

        }
    }
</script>
